<nav class="p-2">
  <ul class="sidenav-list break-word">
    <li *ngFor="let topMenuItem of menuItems" class="mb-3">
      <a
        [routerLink]="[topMenuItem.url]"
        routerLinkActive="active"
        class="mb-3"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ topMenuItem.title }}
      </a>
      <ul class="sidenav-sub_list" *ngIf="topMenuItem.submenuItems?.length > 0">
        <li *ngFor="let subMenuItem of topMenuItem.submenuItems">
          <a [routerLink]="[topMenuItem.url, subMenuItem.url]" routerLinkActive="active">
            {{ subMenuItem.title }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</nav>
